// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerforall {
  margin-top: 3%;
  display: flex;
  justify-content: space-between;
  font-family: "Poppins";
}
.headerforall .leftHeader h1 {
  font-weight: 600;
}
.headerforall .rightHeader a.inActive {
  color: #3fb9ea;
  text-decoration: none;
}

.paragraphforall {
  font-family: "Poppins";
}
.paragraphforall h5.heading {
  color: #d60000;
  font-weight: 700;
}
.paragraphforall h6.subHeading {
  font-weight: 700;
}
.paragraphforall h6.noteHeading {
  font-size: 16px;
}
.paragraphforall ul.lists li.list {
  list-style-type: number;
}
.paragraphforall p.note {
  font-style: italic;
  font-size: 14px;
}
.paragraphforall p.disc {
  font-size: 1rem;
  font-weight: 100 !important;
}

.footerSectionContainer {
  background: #032b3b;
  padding: 3% 0;
}

.scoreBtnFooter {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #28b1e7;
  background: transparent;
  border: none;
  font-family: "Poppins";
}
.scoreBtnFooter::after {
  position: absolute;
  bottom: -2px;
  left: 0;
  content: "";
  width: 100%;
  height: 2px;
  background: #bd0000;
  transform: scale(0, 1);
  transform-origin: right top;
  transition: transform 0.3s;
}
.scoreBtnFooter:hover {
  color: #bd0000;
}
.scoreBtnFooter:hover::after {
  transform-origin: left top;
  transform: scale(1, 1);
}

.footerLinksContainer {
  padding: 20px 0;
}
.footerLinksContainer .footerLinks {
  padding: 0;
}
.footerLinksContainer .footerLinks .footerLinksHere h4 {
  padding-left: 10px;
  color: #fff;
  text-decoration: underline;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists {
  list-style: none;
  padding: 0;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list {
  margin: 10px;
  transition: transform 0.3s;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a {
  position: relative;
  display: inline-block;
  text-decoration: none;
  color: #28b1e7;
  background: transparent;
  border: none;
  font-family: "Poppins";
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a::after {
  position: absolute;
  bottom: -2px;
  left: 0;
  content: "";
  width: 100%;
  height: 2px;
  background: #bd0000;
  transform: scale(0, 1);
  transform-origin: right top;
  transition: transform 0.3s;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a:hover {
  color: #bd0000;
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list a:hover::after {
  transform-origin: left top;
  transform: scale(1, 1);
}
.footerLinksContainer .footerLinks .footerLinksHere .lists .list:hover {
  transform: translateY(-5px);
}
.footerLinksContainer .footerLinks .footerLinksHere .lists:hover h2 {
  color: #d60000;
}

.attentionInvestor {
  text-align: left;
}
.attentionInvestor .attentionHeaders ul {
  list-style: none;
  color: #fff;
  padding: 0;
  margin: 0;
}
.attentionInvestor .attentionHeaders ul li {
  display: inline-block;
}
.attentionInvestor .attentionHeaders ul li:not(:first-child) {
  margin-left: 10px;
  color: #28b1e7;
}
.attentionInvestor .scrolling_Text {
  height: 40px;
  overflow: hidden;
  position: relative;
  background: transparent;
}
.attentionInvestor .scrolling_Text p.scroll {
  text-align: left;
  position: absolute;
  font-family: "Poppins";
  width: 100%;
  height: 100%;
  color: #28b1e7;
  font-weight: 700;
  margin: 0;
  line-height: 20px;
  white-space: nowrap;
  animation: scroll 25s linear infinite;
}
@keyframes scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.attentionInvestor .scrolling_Text p.scroll:hover {
  animation-play-state: paused;
  cursor: pointer;
  color: #bd0000;
}

.usefulLinksContainer {
  margin: 0;
  display: flex;
  color: #ecf0f1;
}
.usefulLinksContainer span {
  color: #3fb9ea;
}
.usefulLinksContainer ul {
  display: flex;
  list-style-type: none;
  margin: 0;
}
.usefulLinksContainer ul li {
  padding: 0 10px;
}
.usefulLinksContainer ul li a {
  color: #ecf0f1;
  text-decoration: none;
}
.usefulLinksContainer ul li a:hover {
  color: #bd0000;
}

.copyrightContainer {
  padding-top: 20px;
}
.copyrightContainer .centerRight {
  display: flex;
  justify-content: center;
}
.copyrightContainer .centerRight p {
  text-align: center;
  color: #ecf0f1;
}
.copyrightContainer .centerRight p a {
  color: #28b1e7;
  text-decoration: none;
}

.accordion-container {
  width: 100%;
}

.accordion-item {
  border: 1px solid #6c757d;
  border-radius: 5px;
  margin-bottom: 15px;
  background-color: #fff;
  transition: border 0.3s;
}
.accordion-item.active {
  border: 1px solid #007bff;
}
.accordion-item.active .accordion-header {
  background-color: #007bff;
  color: #fff;
}
.accordion-item .accordion-header {
  background-color: #6c757d;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.accordion-item .accordion-header .accordion-title {
  font-weight: bold;
}
.accordion-item .accordion-header .accordion-icon {
  transform: rotate(90deg);
  transition: transform 0.3s;
}
.accordion-item .accordion-header .accordion-icon.active {
  transform: rotate(0deg);
}
.accordion-item .accordion-body {
  padding: 10px;
}

@media (max-width: 768px) {
  .accordion-header {
    flex-direction: column;
  }
  .accordion-header .accordion-title {
    margin-bottom: 5px;
  }
  .accordion-header .accordion-icon {
    transform: rotate(0deg);
  }
}
.ticketForm {
  margin-top: 3%;
  font-family: "Poppins", Arial, sans-serif;
}

.formContainer {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 2.5rem 2rem;
  max-width: 540px;
  margin: 0 auto;
}

.formsDataInput .title {
  color: #d60000;
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  text-align: center;
}
.formsDataInput p {
  color: #808080;
  font-size: 1rem;
  margin-bottom: 1.2rem;
  text-align: center;
}
.formsDataInput hr {
  margin: 1.2rem 0 1.5rem 0;
  border: none;
  border-top: 1.5px solid #eaeaea;
}

.ticket-form {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.ticket-form label {
  font-weight: 600;
  color: #3fb9ea;
  margin-bottom: 0.3rem;
}
.ticket-form input, .ticket-form textarea {
  border: 1.5px solid #3fb9ea;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1rem;
  transition: border 0.2s, box-shadow 0.2s;
  margin-bottom: 0.2rem;
  background: #f7fbff;
  resize: none;
  width: 100%;
}
.ticket-form input:focus, .ticket-form textarea:focus {
  outline: none;
  border: 1.5px solid #d60000;
  box-shadow: 0 0 0 2px rgba(214, 0, 0, 0.08);
  background: #fff;
}
.ticket-form button[type=submit] {
  background: #3fb9ea;
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 12px 0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 0.5rem;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(63, 185, 234, 0.08);
  width: 100%;
  letter-spacing: 0.5px;
}
.ticket-form button[type=submit]:hover {
  background: #d60000;
  color: #fff;
  box-shadow: 0 4px 16px rgba(214, 0, 0, 0.1);
}

.wholeDivContainer .modal-content {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.wholeDivContainer .modal-body {
  font-size: 1.1rem;
  color: #3fb9ea;
  text-align: center;
  padding: 2rem 1.5rem;
}
.wholeDivContainer .modal-footer {
  border-top: none;
  justify-content: center;
  padding-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .formContainer {
    padding: 1.2rem 0.5rem;
  }
  .formsDataInput .title {
    font-size: 1.3rem;
  }
  .ticket-form {
    gap: 0.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Defaults/Footer/Style.scss","webpack://./src/Components/Ticket/Style.scss"],"names":[],"mappings":"AAOA;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;ACNF;ADSI;EACE,gBAAA;ACPN;ADYI;EACE,cApBI;EAqBJ,qBAAA;ACVN;;ADgBA;EACE,sBAAA;ACbF;ADeE;EACE,cA9BQ;EA+BR,gBAAA;ACbJ;ADgBE;EACE,gBAAA;ACdJ;ADiBE;EACE,eAAA;ACfJ;ADmBI;EACE,uBAAA;ACjBN;ADqBE;EACE,kBAAA;EACA,eAAA;ACnBJ;ADsBE;EACE,eAAA;EACA,2BAAA;ACpBJ;;ADyBA;EACE,mBAAA;EACA,aAAA;ACtBF;;AD0BA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;ACvBF;ADyBE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;ACvBJ;AD0BE;EACE,cAAA;ACxBJ;AD2BE;EACE,0BAAA;EACA,sBAAA;ACzBJ;;AD8BA;EACE,eAAA;AC3BF;AD6BE;EACE,UAAA;AC3BJ;AD8BM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;AC5BR;AD+BM;EACE,gBAAA;EACA,UAAA;AC7BR;AD+BQ;EACE,YAAA;EACA,0BAAA;AC7BV;AD+BU;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AC7BZ;AD+BY;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AC7Bd;ADgCY;EACE,cAAA;AC9Bd;ADiCY;EACE,0BAAA;EACA,sBAAA;AC/Bd;ADmCU;EACE,2BAAA;ACjCZ;ADqCQ;EACE,cA9JE;AC2HZ;;AD2CA;EACE,gBAAA;ACxCF;AD2CI;EACE,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;ACzCN;AD2CM;EACE,qBAAA;ACzCR;AD2CQ;EACE,iBAAA;EACA,cAAA;ACzCV;AD+CE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AC7CJ;AD+CI;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;AC7CN;AD+CM;EACE;IACE,2BAAA;EC7CR;EDgDM;IACE,4BAAA;EC9CR;AACF;ADiDM;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AC/CR;;ADwDA;EACE,SAAA;EACA,aAAA;EACA,cAAA;ACrDF;ADuDE;EACE,cA3OM;ACsLV;ADwDE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;ACtDJ;ADwDI;EACE,eAAA;ACtDN;ADwDM;EACE,cAAA;EACA,qBAAA;ACtDR;ADwDQ;EACE,cAAA;ACtDV;;AD8DA;EACE,iBAAA;AC3DF;AD6DE;EACE,aAAA;EACA,uBAAA;AC3DJ;AD6DI;EACE,kBAAA;EACA,cAAA;AC3DN;AD6DM;EACE,cAAA;EACA,qBAAA;AC3DR;;AD4EA;EACE,WAAA;ACzEF;;AD6EA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AC1EF;ADgFE;EACE,yBAAA;AC9EJ;ADgFI;EACE,yBA7BU;EA8BV,WAAA;AC9EN;ADkFE;EACE,yBAhCc;EAiCd,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AChFJ;ADkFI;EACE,iBAAA;AChFN;ADmFI;EACE,wBAAA;EACA,0BAAA;ACjFN;ADmFM;EACE,uBAAA;ACjFR;ADsFE;EACE,aAAA;ACpFJ;;ADyFA;EACE;IACE,sBAAA;ECtFF;EDwFE;IACE,kBAAA;ECtFJ;EDyFE;IACE,uBAAA;ECvFJ;AACF;AAvQA;EACE,cAAA;EACA,yCAAA;AAyQF;;AAtQA;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAyQF;;AArQE;EACE,cDhBQ;ECiBR,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AAwQJ;AAtQE;EACE,cDrBG;ECsBH,eAAA;EACA,qBAAA;EACA,kBAAA;AAwQJ;AAtQE;EACE,yBAAA;EACA,YAAA;EACA,+BAAA;AAwQJ;;AApQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAuQF;AArQE;EACE,gBAAA;EACA,cD3CM;EC4CN,qBAAA;AAuQJ;AApQE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAsQJ;AAnQE;EACE,aAAA;EACA,2BAAA;EACA,2CAAA;EACA,gBAAA;AAqQJ;AAlQE;EACE,mBDnEM;ECoEN,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,8CAAA;EACA,WAAA;EACA,qBAAA;AAoQJ;AAlQE;EACE,mBDhFQ;ECiFR,WAAA;EACA,2CAAA;AAoQJ;;AA/PE;EACE,mBAAA;EACA,yCAAA;AAkQJ;AAhQE;EACE,iBAAA;EACA,cD9FM;EC+FN,kBAAA;EACA,oBAAA;AAkQJ;AAhQE;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;AAkQJ;;AA9PA;EACE;IACE,sBAAA;EAiQF;EA/PA;IACE,iBAAA;EAiQF;EA/PA;IACE,WAAA;EAiQF;AACF","sourcesContent":["// Color Variables\r\n$primary: #3fb9ea;\r\n$secondary: #d60000;\r\n$hover: #b80000;\r\n$gray: #808080;\r\n\r\n// *** Styles For All Links\r\n.headerforall {\r\n  margin-top: 3%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-family: \"Poppins\";\r\n\r\n  .leftHeader {\r\n    h1 {\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  .rightHeader {\r\n    a.inActive {\r\n      color: $primary;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n// *** Disclaimer\r\n.paragraphforall {\r\n  font-family: \"Poppins\";\r\n\r\n  h5.heading {\r\n    color: $secondary;\r\n    font-weight: 700;\r\n  }\r\n\r\n  h6.subHeading {\r\n    font-weight: 700;\r\n  }\r\n\r\n  h6.noteHeading {\r\n    font-size: 16px;\r\n  }\r\n\r\n  ul.lists {\r\n    li.list {\r\n      list-style-type: number;\r\n    }\r\n  }\r\n\r\n  p.note {\r\n    font-style: italic;\r\n    font-size: 14px;\r\n  }\r\n\r\n  p.disc {\r\n    font-size: 1rem;\r\n    font-weight: 100 !important;\r\n  }\r\n}\r\n\r\n// *** Footer Styles\r\n.footerSectionContainer {\r\n  background: #032b3b;\r\n  padding: 3% 0;\r\n}\r\n\r\n// Score Btn Footer\r\n.scoreBtnFooter {\r\n  position: relative;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  color: darken($primary, 5%);\r\n  background: transparent;\r\n  border: none;\r\n  font-family: \"Poppins\";\r\n\r\n  &::after {\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: 0;\r\n    content: \"\";\r\n    width: 100%;\r\n    height: 2px;\r\n    background: darken($secondary, 5%);\r\n    transform: scale(0, 1);\r\n    transform-origin: right top;\r\n    transition: transform 0.3s;\r\n  }\r\n\r\n  &:hover {\r\n    color: darken($secondary, 5%);\r\n  }\r\n\r\n  &:hover::after {\r\n    transform-origin: left top;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n// Footer links\r\n.footerLinksContainer {\r\n  padding: 20px 0;\r\n\r\n  .footerLinks {\r\n    padding: 0;\r\n\r\n    .footerLinksHere {\r\n      h4 {\r\n        padding-left: 10px;\r\n        color: #fff;\r\n        text-decoration: underline;\r\n      }\r\n\r\n      .lists {\r\n        list-style: none;\r\n        padding: 0;\r\n\r\n        .list {\r\n          margin: 10px;\r\n          transition: transform 0.3s;\r\n\r\n          a {\r\n            position: relative;\r\n            display: inline-block;\r\n            text-decoration: none;\r\n            color: darken($primary, 5%);\r\n            background: transparent;\r\n            border: none;\r\n            font-family: \"Poppins\";\r\n\r\n            &::after {\r\n              position: absolute;\r\n              bottom: -2px;\r\n              left: 0;\r\n              content: \"\";\r\n              width: 100%;\r\n              height: 2px;\r\n              background: darken($secondary, 5%);\r\n              transform: scale(0, 1);\r\n              transform-origin: right top;\r\n              transition: transform 0.3s;\r\n            }\r\n\r\n            &:hover {\r\n              color: darken($secondary, 5%);\r\n            }\r\n\r\n            &:hover::after {\r\n              transform-origin: left top;\r\n              transform: scale(1, 1);\r\n            }\r\n          }\r\n\r\n          &:hover {\r\n            transform: translateY(-5px);\r\n          }\r\n        }\r\n\r\n        &:hover h2 {\r\n          color: $secondary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Attention Investor\r\n.attentionInvestor {\r\n  text-align: left;\r\n\r\n  .attentionHeaders {\r\n    ul {\r\n      list-style: none;\r\n      color: #fff;\r\n      padding: 0;\r\n      margin: 0;\r\n\r\n      li {\r\n        display: inline-block;\r\n\r\n        &:not(:first-child) {\r\n          margin-left: 10px;\r\n          color: darken($primary, 5%);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .scrolling_Text {\r\n    height: 40px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    background: transparent;\r\n\r\n    p.scroll {\r\n      text-align: left;\r\n      position: absolute;\r\n      font-family: \"Poppins\";\r\n      width: 100%;\r\n      height: 100%;\r\n      color: darken($primary, 5%);\r\n      font-weight: 700;\r\n      margin: 0;\r\n      line-height: 20px;\r\n      white-space: nowrap;\r\n      animation: scroll 25s linear infinite;\r\n\r\n      @keyframes scroll {\r\n        0% {\r\n          transform: translateX(100%);\r\n        }\r\n\r\n        100% {\r\n          transform: translateX(-100%);\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        animation-play-state: paused;\r\n        cursor: pointer;\r\n        color: darken($secondary, 5%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n// Useful Links\r\n.usefulLinksContainer {\r\n  margin: 0;\r\n  display: flex;\r\n  color: #ecf0f1;\r\n\r\n  span {\r\n    color: $primary;\r\n  }\r\n\r\n  ul {\r\n    display: flex;\r\n    list-style-type: none;\r\n    margin: 0;\r\n\r\n    li {\r\n      padding: 0 10px;\r\n\r\n      a {\r\n        color: #ecf0f1;\r\n        text-decoration: none;\r\n\r\n        &:hover {\r\n          color: darken($secondary, 5%);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Copyright\r\n.copyrightContainer {\r\n  padding-top: 20px;\r\n\r\n  .centerRight {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    p {\r\n      text-align: center;\r\n      color: #ecf0f1;\r\n\r\n      a {\r\n        color: darken($primary, 5%);\r\n        text-decoration: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// NSE Arbitration Rules\r\n// Define a primary color for the accordion\r\n$primary-color: #007bff;\r\n\r\n// Define a secondary color for the accordion\r\n$secondary-color: #6c757d;\r\n\r\n// Define a transition duration for smooth animations\r\n$transition-duration: 0.3s;\r\n\r\n// Accordion container\r\n.accordion-container {\r\n  width: 100%;\r\n}\r\n\r\n// Accordion items\r\n.accordion-item {\r\n  border: 1px solid $secondary-color;\r\n  border-radius: 5px;\r\n  margin-bottom: 15px;\r\n  background-color: #fff;\r\n  transition: border $transition-duration;\r\n\r\n  &:hover {\r\n    // border: 1px solid $primary-color;\r\n  }\r\n\r\n  &.active {\r\n    border: 1px solid $primary-color;\r\n\r\n    .accordion-header {\r\n      background-color: $primary-color;\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  .accordion-header {\r\n    background-color: $secondary-color;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    .accordion-title {\r\n      font-weight: bold;\r\n    }\r\n\r\n    .accordion-icon {\r\n      transform: rotate(90deg);\r\n      transition: transform $transition-duration;\r\n\r\n      &.active {\r\n        transform: rotate(0deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  .accordion-body {\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n// Media query for smaller screens\r\n@media (max-width: 768px) {\r\n  .accordion-header {\r\n    flex-direction: column;\r\n\r\n    .accordion-title {\r\n      margin-bottom: 5px;\r\n    }\r\n\r\n    .accordion-icon {\r\n      transform: rotate(0deg);\r\n    }\r\n  }\r\n}\r\n","@import '../../Defaults/Footer/Style.scss';\r\n\r\n.ticketForm {\r\n  margin-top: 3%;\r\n  font-family: 'Poppins', Arial, sans-serif;\r\n}\r\n\r\n.formContainer {\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\r\n  padding: 2.5rem 2rem;\r\n  max-width: 540px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.formsDataInput {\r\n  .title {\r\n    color: $secondary;\r\n    font-weight: 700;\r\n    font-size: 2rem;\r\n    margin-bottom: 0.5rem;\r\n    text-align: center;\r\n  }\r\n  p {\r\n    color: $gray;\r\n    font-size: 1rem;\r\n    margin-bottom: 1.2rem;\r\n    text-align: center;\r\n  }\r\n  hr {\r\n    margin: 1.2rem 0 1.5rem 0;\r\n    border: none;\r\n    border-top: 1.5px solid #eaeaea;\r\n  }\r\n}\r\n\r\n.ticket-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.1rem;\r\n\r\n  label {\r\n    font-weight: 600;\r\n    color: $primary;\r\n    margin-bottom: 0.3rem;\r\n  }\r\n\r\n  input, textarea {\r\n    border: 1.5px solid $primary;\r\n    border-radius: 8px;\r\n    padding: 10px 14px;\r\n    font-size: 1rem;\r\n    transition: border 0.2s, box-shadow 0.2s;\r\n    margin-bottom: 0.2rem;\r\n    background: #f7fbff;\r\n    resize: none;\r\n    width: 100%;\r\n  }\r\n\r\n  input:focus, textarea:focus {\r\n    outline: none;\r\n    border: 1.5px solid $secondary;\r\n    box-shadow: 0 0 0 2px rgba(214,0,0,0.08);\r\n    background: #fff;\r\n  }\r\n\r\n  button[type=\"submit\"] {\r\n    background: $primary;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 25px;\r\n    padding: 12px 0;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    margin-top: 0.5rem;\r\n    transition: background 0.2s, box-shadow 0.2s;\r\n    box-shadow: 0 2px 8px rgba(63,185,234,0.08);\r\n    width: 100%;\r\n    letter-spacing: 0.5px;\r\n  }\r\n  button[type=\"submit\"]:hover {\r\n    background: $secondary;\r\n    color: #fff;\r\n    box-shadow: 0 4px 16px rgba(214,0,0,0.10);\r\n  }\r\n}\r\n\r\n.wholeDivContainer {\r\n  .modal-content {\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 12px rgba(0,0,0,0.10);\r\n  }\r\n  .modal-body {\r\n    font-size: 1.1rem;\r\n    color: $primary;\r\n    text-align: center;\r\n    padding: 2rem 1.5rem;\r\n  }\r\n  .modal-footer {\r\n    border-top: none;\r\n    justify-content: center;\r\n    padding-bottom: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .formContainer {\r\n    padding: 1.2rem 0.5rem;\r\n  }\r\n  .formsDataInput .title {\r\n    font-size: 1.3rem;\r\n  }\r\n  .ticket-form {\r\n    gap: 0.7rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
